import {  apiPostRequest } from "../utils/webrequests";
import { ContactUs } from "../data/contactUsData";

export async function sendContactUsInfo(contactUsInfo: ContactUs): Promise<any> {
    try {
        await apiPostRequest("ContactUs", contactUsInfo);
    } catch (error: any) {
        throw new Error("Error sending contact us info: " + error.message);
    }
    }